"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withFile = exports.insertFile = exports.removeFileAtPath = exports.isFileElement = void 0;
const slate_1 = require("slate");
const voidInsert_1 = require("./voidInsert");
const isFileElement = (node) => slate_1.Element.isElement(node) && node.type === 'file';
exports.isFileElement = isFileElement;
const createParagraphElement = () => ({
    type: 'p',
    children: [{ text: '' }],
});
const createFileElement = (thingId, caption) => {
    const el = {
        type: 'file',
        '@thing': thingId,
        children: [{ text: '' }],
    };
    if (caption && caption.trim())
        el.caption = caption.trim();
    return el;
};
const getActiveFileEntry = (editor) => {
    const { selection } = editor;
    if (!selection)
        return;
    const match = slate_1.Editor.above(editor, {
        at: slate_1.Editor.unhangRange(editor, selection),
        match: (node) => (0, exports.isFileElement)(node),
    });
    return match ?? void 0;
};
const insertParagraphNearActiveFile = (editor, position = 'below') => {
    const entry = getActiveFileEntry(editor);
    if (!entry)
        return null;
    const [, path] = entry;
    const targetPath = position === 'above' ? path : slate_1.Path.next(path);
    slate_1.Transforms.insertNodes(editor, createParagraphElement(), { at: targetPath });
    slate_1.Transforms.select(editor, slate_1.Editor.start(editor, targetPath));
    return targetPath;
};
const removeFileAtPath = (editor, path) => {
    if (!slate_1.Node.has(editor, path))
        return false;
    const node = slate_1.Node.get(editor, path);
    if (!(0, exports.isFileElement)(node))
        return false;
    slate_1.Transforms.removeNodes(editor, { at: path });
    return true;
};
exports.removeFileAtPath = removeFileAtPath;
const insertFile = (editor, thingId, caption) => {
    if (!thingId)
        return null;
    return (0, voidInsert_1.insertVoidBlock)(editor, createFileElement(thingId, caption));
};
exports.insertFile = insertFile;
const withFile = (editor) => {
    const { isVoid, insertBreak, insertSoftBreak, insertText } = editor;
    editor.isVoid = (element) => (element.type === 'file' ? true : isVoid(element));
    editor.insertBreak = () => {
        if (insertParagraphNearActiveFile(editor, 'below'))
            return;
        insertBreak();
    };
    editor.insertSoftBreak = () => {
        if (insertParagraphNearActiveFile(editor, 'above'))
            return;
        insertSoftBreak();
    };
    editor.insertText = (text) => {
        if (text && insertParagraphNearActiveFile(editor, 'below')) {
            insertText(text);
            return;
        }
        insertText(text);
    };
    return editor;
};
exports.withFile = withFile;
